module.exports = __webpack_public_path__ + "assets/img/6343-mh.svg";